export default __webpack_public_path__ + "static/media/ennovate_11.4651c58c.jpg";